export default {
  allUsers: [],
  user: {},
};
